var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Header'),_c('v-container',[_c('v-list',{attrs:{"two-line":""}},[_c('v-subheader',[_vm._v("MessageList")]),_vm._l((_vm.idList),function(id,index){return [_c('v-list-item',{key:index},[_c('v-list-item-avatar',[_c('v-img',{attrs:{"src":_vm.getImgUrl(id)}})],1),_c('v-list-item-content',[_c('router-link',{attrs:{"to":{
                name:'Chat',
                params: {
                  id: id,
                  imgUrl: _vm.getImgUrl(id)
                }
              }}},[_c('v-list-item-title',{domProps:{"textContent":_vm._s(_vm.getLastMessage(id))}}),_c('v-list-item-subtitle',{domProps:{"textContent":_vm._s(_vm.getLastChatTime(id))}})],1)],1)],1)]})],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }